import React from "react";
import { Helmet } from "react-helmet-async";
import { injectIntl, IntlShape } from "react-intl";
import { match as Match } from "react-router-dom";
import NotificationForm from "../form";
import { withTwoColLayout } from "../../../utils";
import PageSubheader from "../../../components/PageSubheader";
import { EnumNotificationType } from "../../../lib/ground-aws-graphql-core/api/graphql/types";

interface Props {
  notificationType?: EnumNotificationType;
  match: Match<{ cid: string }>;
  intl: IntlShape;
  backURL: string;
}

const NotificationCreate = (props: Props) => {
  const { intl, backURL } = props;

  return (
    <>
      <Helmet>
        <title>
          {intl.formatMessage({
            id: "page.notification.create.document.title",
          })}
        </title>
      </Helmet>

      <PageSubheader
        goBackEnabled
        goBackId="btn-back-notification-create"
        goBackURL={backURL}
      />

      <NotificationForm {...props} />
    </>
  );
};

export default withTwoColLayout(injectIntl(NotificationCreate));
